import { aotLoader } from './src/loader';

export { AotPlugin } from './src/plugin';
export default aotLoader;
